import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import PaginationURL from "util/PaginationURL";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
import { fetchTextFile } from "util/FileDownloadUtils";
const BASE_URL = "/system/translation_feedback";
export const keyFn = (searchParams) => ["translationFeedback", searchParams];
export const fetchTranslationFeedback = (searchParams) => {
  const url = PaginationURL(
    qualifyUrl(`${BASE_URL}/paginated`),
    searchParams.page,
    searchParams.pageSize,
    searchParams.query,
    {
      filters: FiltersForQueryParams(searchParams.filters),
      sort: searchParams.sort.attributeId,
      order: searchParams.sort.direction
    }
  );
  return fetch("GET", url).then(({ elements, total, attributes }) => ({
    list: elements,
    pagination: { total },
    attributes
  }));
};
export const createTranslationFeedback = (feedback) => fetch("POST", qualifyUrl(BASE_URL), feedback);
export const updateTranslationFeedbackStatus = (id, status) => fetch("PUT", qualifyUrl(`${BASE_URL}/${encodeURIComponent(id)}/status`), { status });
export const deleteTranslationFeedback = (id) => fetch("DELETE", qualifyUrl(`${BASE_URL}/${encodeURIComponent(id)}`));
export const bulkUpdateTranslationFeedbackStatus = (ids, status) => fetch("POST", qualifyUrl(`${BASE_URL}/bulk_status`), { ids, status });
export const bulkDeleteTranslationFeedback = (ids) => fetch("POST", qualifyUrl(`${BASE_URL}/bulk_delete`), { ids });
export const applyTranslationFeedbackResolutions = (resolutions) => fetch("POST", qualifyUrl(`${BASE_URL}/resolutions`), resolutions);
const EXPORT_MIME_TYPES = { json: "application/json", csv: "text/csv" };
export const exportTranslationFeedback = (format, searchParams) => {
  var _a;
  const params = [
    ...searchParams.query ? [["query", searchParams.query]] : [],
    ...((_a = FiltersForQueryParams(searchParams.filters)) != null ? _a : []).map((filter) => ["filters", filter])
  ];
  const query = params.map(([name, value]) => `${name}=${encodeURIComponent(value)}`).join("&");
  const url = qualifyUrl(`${BASE_URL}/export/${format}${query ? `?${query}` : ""}`);
  const date = (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
  return fetchTextFile("GET", url, void 0, EXPORT_MIME_TYPES[format], `translation-feedback-${date}.${format}`);
};
